import mapboxgl from "mapbox-gl";
import { mapToken } from "@/constants/tokens";
import { getFirstSymbolId, mapIcons } from "../configs/";
import { getWidgetStyleConfig } from "../../../configs";
import {
  MatrixController,
  TrafficLightsController,
  TagilMatrixController,
  TagilPtRouteController
} from "../helpers";

export const initMap = component => {
  const theme = component.theme;
  const style =
    theme === "dark-theme"
      ? `mapbox://styles/aplussmoscow/ckea67vfv6oxu1aoxuaikbgvm`
      : `mapbox://styles/mapbox/light-v9`;

  mapboxgl.accessToken = mapToken;

  const center = component.mapConfig.center;
  const maxBounds = component.mapConfig.maxBounds;
  const zoom = component.mapConfig.zoom;

  component.mapgl = new mapboxgl.Map({
    container: "situation-center-map",
    maxBounds,
    center,
    zoom,
    style
  });
  component.mapgl.dragRotate.disable();

  component.mapgl.on("mousemove", e => {
    const mapLayers = component.eventAvaliableLayers.filter(l =>
      component.mapgl.getLayer(l)
    );

    if (component.trackLayer.layer_id) mapLayers.push("track_layer_sc_map");
    if (!mapLayers.length) return;

    const { x, y } = e.point;
    const bbox = [[x - 5, y - 5], [x + 5, y + 5]];
    const features = component.mapgl.queryRenderedFeatures(bbox, {
      layers: mapLayers
    });

    if (!features.length) {
      component.mapgl.getCanvas().style.cursor = "";
      component.popupSettings.display = "none";
      component.popupSettings.values = [];
      component.popupSettings.layer_id = "";
      return;
    }

    component.mapgl.getCanvas().style.cursor = "pointer";
    const feature = features[0];
    const { properties, layer } = feature;
    const layerId = layer.id.includes("_sc_map")
      ? layer.id.split("_sc_map")[0]
      : layer.id;

    const { icons, colors, fields } = getWidgetStyleConfig(layerId);
    component.popupSettings.top = y - 38;
    component.popupSettings.left = x + 10;
    component.popupSettings.display = "flex";
    component.popupSettings.layer_id = layerId;
    component.popupSettings.colors = colors;
    component.popupSettings.icons = icons;

    if (Object.keys(fields).length) {
      component.popupSettings.type = properties[fields.type];
      component.popupSettings.values = Object.keys(fields).map(key => ({
        key,
        value:
          properties[fields[key]] === "null" ? null : properties[fields[key]]
      }));
    }
  });

  component.mapgl.on("mouseout", () => {
    component.popupSettings.display = "none";
    component.popupSettings.values = [];
    component.popupSettings.layer_id = "";
  });

  component.mapgl.on("movestart", () => {
    component.popupSettings.display = "none";
    component.popupSettings.values = [];
    component.popupSettings.layer_id = "";
  });

  component.mapgl.on("click", e => {
    const mapLayers = component.eventAvaliableLayers.filter(l =>
      component.mapgl.getLayer(l)
    );
    if (!mapLayers.length) return;

    const { x, y } = e.point;
    const bbox = [[x - 5, y - 5], [x + 5, y + 5]];
    const features = component.mapgl.queryRenderedFeatures(bbox, {
      layers: mapLayers
    });

    if (!features.length) return;
    const feature = features[0];
    const { properties, layer } = feature;
    if (layer.id === "tagil_rt_stops_point_active") return;
    if (layer.id === "tagil_rt_routes_lines") return;
    const layerId = layer.id.includes("_sc_map")
      ? layer.id.split("_sc_map")[0]
      : layer.id;

    component.targetClickHandler(feature, properties.id, layerId);
  });

  component.mapgl.on("load", () => {
    Promise.all(
      mapIcons.map(
        ({ name, icon }) =>
          new Promise(resolve => {
            component.mapgl.loadImage(component[icon], function(error, res) {
              component.mapgl.addImage(name, res);
              resolve();
            });
          })
      )
    ).then(() => {
      component.isReady = true;
      component.updateActiveLayers();
      component.updateActiveTileLayers();
      component.updateTrackLayer();
    });

    if (component.tileLayers && component.tileLayers.length) {
      component.tileLayers.forEach(e => {
        if (!component.mapgl.getLayer(e.id)) {
          component.mapgl.addLayer(e, getFirstSymbolId(component.mapgl));
          component.mapgl.setLayoutProperty(e.id, "visibility", "none");
        }
      });
    }
  });

  component.TrafficLightsController = new TrafficLightsController(component);
  component.MatrixController = new MatrixController(component);

  if (component.instance === "tagil") {
    component.TagilMatrixController = new TagilMatrixController(component);
    component.TagilPtRouteController = new TagilPtRouteController(component);
    component.TagilPtRouteController.toggleItems();

    component.eventAvaliableLayers.push("tagil_matrix_lines");
    component.eventAvaliableLayers.push("tagil_rt_stops_point_active");
    component.eventAvaliableLayers.push("tagil_rt_routes_lines");
  }
};
